import Decimal from "decimal.js";

const React = require('react');
import {Grid, Box} from "@material-ui/core";
import {PAYMENT_METHODS_LIST} from "../../../../../../../../constants/paymentMethods";
const {object, string} = require("yup");
const {FormWrapper, FormFooter} = require('../../../../../../../dumb/FormHandlers');
const {AdminSelect, AdminInput, AdminCheckbox} = require("../../../../../../../dumb/FormInputs");

const {apiAdminMerchantActivate} = require("../../../../../../../../api/admin/retailersCreate");

const {pushLocation} = require("../../../../../../../../router");
const {getAdminRetailersLink} = require("../../../../../../../../utils/adminLinkCtor");


module.exports = ({account_id, close}) => {
  return (
    <FormWrapper
      data={{
        rolling_reserve: '0',
        payment_methods: ['mastercard', 'visa', 'applepay']
      }}
      schema={object({
        entity_id: string().required(),
        rolling_reserve: string()
          .positiveNumber()
          .test('max', 'Maximum 100%', (val) => Number(val) <= 100)
          .integer()
      })}
      onSubmit={({rolling_reserve: rrPercent, ...props}) => {
        const rolling_reserve = rrPercent
          ? new Decimal(rrPercent).dividedBy('100').toString()
          : '0';

        return (
          apiAdminMerchantActivate({account_id, rolling_reserve, ...props})
        )
      }}
      onResult={({account_id}) => {
        pushLocation({
          path: getAdminRetailersLink(account_id)
        });
        close();
      }}
    >{(formCtx) => {
        const methods = formCtx.state.data.payment_methods || [];

        return (
          <>
            <Box mt="28px">
              <Grid container spacing={8}>
                <Grid sm={8} item>
                  <AdminSelect
                    propName="name"
                    propValue="id"
                    items={[
                      {id: 'lunu_uab_europe', name: 'Lunu UAB Europe (Lithuania)'},
                      {id: 'web3_solutions_srl', name: 'Web3 Solutions Srl (Italy)'}
                    ]}

                    name="entity_id"
                    label="Lunu Legal Entity"
                    formCtx={formCtx}
                  />
                </Grid>
                <Grid sm={4} item>
                  <AdminInput
                    name="rolling_reserve"
                    label="Rolling Reserve"
                    endAdornment={(
                      <span className="w26 pv12 f16 o50">
                        %
                      </span>
                    )}
                    formCtx={formCtx}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box mt="14px">
              <div>Default Payment Gateway Setup</div>
            </Box>
            <Box my="14px">
              <Grid container spacing={2}>
                {PAYMENT_METHODS_LIST.map((el) => {
                  return (
                    <Grid key={el.id} sm={4} item>
                      <AdminCheckbox
                        name={`payment_method_${el.id}`}
                        label={el.name}

                        value={methods.includes(el.id)}
                        onChange={() => {
                          let nextMethods = [...methods];

                          if (methods.includes(el.id)) {
                            nextMethods = nextMethods.filter((method) => method !== el.id)
                          } else {
                            nextMethods.push(el.id);
                          }

                          formCtx.onChange('payment_methods', nextMethods);
                        }}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
            <FormFooter
              submitBtnData={{
                text: 'Activate Retailer',
                testId: 'activateRetailer',
                formCtx
              }}
              additionalBtnsList={[
                {text: 'Cancel', onClick: close},
              ]}
            />
          </>
        )
    }}</FormWrapper>
  )
}
